import { Box, Grid, Stack, Tooltip, Typography } from '@mui/material';

import Copyright from './Copyright';
import LanguageSelector from '../common/LanguageSelector';

import './Footer.css';
import { useTranslation } from 'react-i18next';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <Box mb={2} mt={2} className="login-footer">
        <Grid container direction="row" justifyContent="center" alignItems="stretch">
          <Grid item xs={12}>
            <Box mb={1}>
              <LanguageSelector data-qa-element-id="language-selector" /*onLanguageChange={handleLanguageChange}*/ />
            </Box>

            <Box my={1.5}>
              {isPhoneOrHighScreen() && (
                <Typography
                  variant="helperText"
                  color="textSecondary"
                  lineHeight={1}
                  data-qa-element-id="phone_for_registration_label"
                >
                  {t('registration.body')}
                </Typography>
              )}
            </Box>
          </Grid>

          <Grid item xs={2} container justifyContent="flex-start" alignContent="center">
            {/* <PresenterIcon presenter={device.presenter} /> */}
          </Grid>

          <Grid item xs={10} container justifyContent="flex-end" alignContent="center" gap={1}>
            <Tooltip title="build ID">
              <Stack spacing={1} direction="row">
                <Typography variant="helperText">{VERSION}</Typography>
                <Typography variant="helperText">
                  &nbsp; b{BUILD_NUMBER}
                  &nbsp; ({ENVIRONMENT})
                </Typography>
              </Stack>
            </Tooltip>
            <Copyright />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Footer;
